import CrossSellListSFC from "./CrossSellList.vue";
export const CrossSellList = CrossSellListSFC;
